export default __webpack_public_path__ + "static/media/sushi.01078391.png";